export default __webpack_public_path__ + "static/media/fheQmUDk.92bc9a0f.svg";